import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  gap: 10px;
`;
